import { BaseEditModel } from "model/BaseEditModel";
import OperacaoProducao from "./OperacaoProducao";
import MetaProducao from "./MetaProducao";
import ApontamentoOperacao from "./ApontamentoOperacao";

export default class MetaProducaoOperacao implements BaseEditModel {
    id: number | null;
    codigo: string | null="";
    key: string | null="";
    sequencial: number;
    descricao: string;
    quantidadeOperadores: number;
    qualidade: boolean;
    operacao: OperacaoProducao | null;
    metaProducao: MetaProducao | null;
    apontamentos: ApontamentoOperacao[];

    constructor(
        id = null,
        sequencial = 0,
        descricao = '',
        quantidadeOperadores = 0,
        qualidade = false,
        operacao = null,
        metaProducao = null,
        apontamentos = []
    ) {
        this.id = id;
        this.sequencial = sequencial;
        this.descricao = descricao;
        this.quantidadeOperadores = quantidadeOperadores;
        this.qualidade = qualidade;
        this.operacao = operacao;
        this.metaProducao = metaProducao;
        this.apontamentos = apontamentos;
    }
}